import { render, staticRenderFns } from "./ContentCommentsPage.vue?vue&type=template&id=f49594d2&scoped=true&"
import script from "./ContentCommentsPage.vue?vue&type=script&lang=js&"
export * from "./ContentCommentsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContentCommentsPage.vue?vue&type=style&index=0&id=f49594d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49594d2",
  null
  
)

export default component.exports